import React, { useEffect, useState } from "react";
import { BackButton } from "../../components/btn/Buttons";
import PageHeading from "../../components/PageHeading";
import { Input } from "../../components/inputs/Inputs";
import Dropdown from "../../components/inputs/Dropdown";
import Button from "../../components/btn/Button";
import { useSelector } from "react-redux";
import Table from "../../components/table/Table";
import store from "../../redux/store";
import { get_sales_report_list } from "./transactionReportSlice";
import { DateValidatorReports } from "../../utils/validation";
import moment from "moment";
import SmallModal from "../../components/modal/SmallModal";
import Loader from "../../components/Loader";
import { sales_report_api } from "../../utils/apis";
import { Pagination3 } from "../../components/pagination/pagination";
import NoData from "../../components/NoData";
import { downloadExcel, exportPDF } from "../../utils/utils";
import { Alerts } from "../../components/Alerts/Alerts";
import { get_transition_complete_list } from "../transactions/trasactionsSlice";
import SearchApiHook from "../../CustomHooks/SearchApiHook";

const SalesReport = () => {
  const [addData, setAddData] = useState({});
  const [addDataPre, setAddDataPre] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [mess, setMess] = useState("");
  const [totalCount, setTotalCount] = useState("50");
  const [entries, setEntries] = useState("5");
  const [pageNo, setPageNo] = useState(1);
  const [serchInput, setSerchInput] = useState("");
  const [showData, setShowData] = useState(false);
  const [prevSearch, setPrevSearch] = useState("");
  const [SearchCount, setSearchCount] = useState(0);
  const [purchase_report_item_list, setPurchase_report_item_list] = useState(
    []
  );

  const { transition_complete_list } = useSelector(
    (state) => state.transactions
  );
  const [totalData, setTotalData] = useState({});
  const { firm_name } = useSelector((state) => state.profile);
  const { sales_report_list } = useSelector((state) => state.transactionReport);
  const { user_id } = useSelector((state) => state.other);

  useEffect(() => {
    store.dispatch(get_sales_report_list());
    store.dispatch(get_transition_complete_list());
  }, []);

  const fetchData = () => {
    if (showData) {
      get_list(addDataPre);
    }
  };
  SearchApiHook(fetchData, serchInput?.trim(), prevSearch, [entries, pageNo]);

  const table_data = (addData, total) => {
    const data = [
      ...addData?.map((v, i) => [
        i + 1,
        v?.SR_NO,
        v?.INV_DATE,
        v?.GODOWN_NAME || "-",
        `${v?.CAT_NAME} - ${v?.CAT_DESC}`,
        v?.HSN_CODE,
        v?.GSTP,
        v?.CVO_NAME,
        v?.CVO_TIN || "NA",
        v?.EMP_NAME,
        Number(v?.QUANTITY || 0),
        Number(v?.PREPAID || 0),
        Number(v?.PSV || 0),
        Number(v?.EMPTY_RECEIVED),
        "NOS",
        v?.UNIT_RATE,
        v?.DISC_UNIT_RATE,
        Number(v?.TAXABLE_VALUE),
        Number(v?.IGST_AMOUNT),
        Number(v?.CGST_AMOUNT),
        Number(v?.SGST_AMOUNT),
        Number(v?.INV_AMOUNT),
        Number(v?.CASH_RECEIVED),
        Number(v?.ONLINE_RECEIVED),
        v?.TRANSACTION_ID,
        v?.BANK_ACCOUNT,
        v?.CREATED_NAME,
        moment(v?.CREATED_DATE).format("DD/MM/YYYY hh:mm A"),
      ]),
      [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "TOTAL",
        "",
        Number(total?.quantity),
        Number(total?.PREPAID),
        Number(total?.PSV),
        "",
        "",
        "",
        "",
        Number(total?.taxable),
        Number(total?.igst),
        Number(total?.cgst),
        Number(total?.sgst),
        Number(total?.inv_amount),
      ],
    ];
    return data;
  };

  const table_header = [
    "INVOICE NO",
    "INVOICE DATE",
    "GODOWN NAME",
    "PRODUCT",
    "HSN CODE",
    "GST RATE",
    "CUSTOMER",
    "CUSTOMER GSTIN",
    "DELIVERED BY/STAFF NAME",
    "QTY",
    "PREPAID / ONLINE",
    "PSV CYLINDERS",
    "EMPTIES RECEIVED",
    "UNITS",
    "UNIT PRICE",
    "DISCOUNT",
    "TAXABLE VALUE",
    "IGST AMOUNT",
    "CGST AMOUNT",
    "SGST AMOUNT",
    "INVOICE AMOUNT",
    "CASH RECEIVED",
    "ONLINE RECEIVED",
    "TRANSACTION ID",
    "BANK ACCOUNT",
    "CREATED BY",
    "CREATED DATE",
  ];

  const export_pdf = (addData, data, total) => {
    exportPDF({
      table_data: table_data(data, total),
      table_headers: ["S.No.", ...table_header],
      fileName: `${firm_name} - SALES REPORTS -- FROM DATE : ${moment(
        addData?.from_date
      ).format("DD/MM/YY")} & TO DATE : ${moment(addData?.to_date).format(
        "DD/MM/YY"
      )}   :: SELECTED : : ${addData?.custProdDetails}`,
      tableName: `${firm_name} - SALES REPORTS -- FROM DATE : ${moment(
        addData?.from_date
      ).format("DD/MM/YY")} & TO DATE : ${moment(addData?.to_date).format(
        "DD/MM/YY"
      )}   :: SELECTED : : ${addData?.custProdDetails}`,
    });
  };

  const export_excel = (addData, data, total) => {
    downloadExcel(
      table_data(data, total),
      ["S.No.", ...table_header],
      `${firm_name} - SALES REPORTS -- FROM DATE : ${moment(
        addData?.from_date
      ).format("DD/MM/YY")} & TO DATE : ${moment(addData?.to_date).format(
        "DD/MM/YY"
      )}   :: SELECTED : : ${addData?.custProdDetails}`
    );
  };

  const get_list = async (addData, data1 = "") => {
    const data = validate(addData);
    if (data?.length == 0) {
      try {
        setShowLoader(true);
        const body = new FormData();
        body.append("action", addData?.action);
        body.append("agencyid", user_id);
        body.append("sdate", addData?.from_date);
        body.append("edate", addData?.to_date);
        body.append("page", data1?.length > 1 || data1 == "main" ? 1 : pageNo);
        body.append(
          "limit",
          data1?.length > 1 ? (data1 == "main" ? entries : totalCount) : entries
        );
        body.append("search", data1 == "main" ? "" : serchInput);

        if (addData?.action == "staff") {
          body.append("staffid", addData?.staffid);
        } else if (addData?.action == "product") {
          body.append("productid", addData?.product_code);
          body.append("prod_cat", addData?.product_cat);
        } else if (addData?.action == "customer") {
          body.append(
            "customerid",
            addData?.customer_id == "CASH SALES" ? 0 : addData?.customer_id
          );
        }
        if (addData?.action == "vehicle") {
          body.append("vehicle_id", addData?.vehicleid);
        }

        const response = await sales_report_api(body);
        setShowLoader(false);

        if (response.success) {
          if (data1 == "excel") {
            export_excel(
              addData,
              response?.data || response?.productlist,
              response?.total
            );
          } else if (data1 == "pdf") {
            export_pdf(
              addData,
              response?.data || response?.productlist,
              response?.total
            );
          } else {
            setPurchase_report_item_list(
              response?.data || response?.productlist
            );
            setTotalCount(response?.totalcount);
            setSearchCount(response?.searchcount);
            setShowData(true);
            setAddDataPre(addData);
            setTotalData(response?.total);
          }
        } else if (!response.success) {
          setMess(response?.message);
          setOpen(true);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setMess(<Alerts data={data} />);
      setOpen(true);
    }
  };

  const validate = (addData) => {
    const data = [];
    const DateValidatorReportsData = DateValidatorReports(
      moment(addData?.from_date).format("DD/MM/YYYY"),
      moment(addData?.to_date).format("DD/MM/YYYY")
    );
    if (
      !addData?.from_date ||
      (addData?.from_date && addData?.from_date?.length != 10)
    ) {
      data.push("Please Enter From Date");
    } else if (
      !addData?.to_date ||
      (addData?.to_date && addData?.to_date?.length != 10)
    ) {
      data.push("Please Enter TO DATE");
    } else if (DateValidatorReportsData != true) {
      data.push(...DateValidatorReportsData);
    }
    if (!addData?.action || (addData?.action && addData?.action?.length == 0)) {
      data.push("Please Select Type of Sales");
    }
    return data;
  };

  // CHANGED: Calculate rowspan map based on SR_NO
  const getRowSpanMap = (data, key) => {
    const map = {};
    data.forEach((item) => {
      map[item[key]] = (map[item[key]] || 0) + 1;
    });
    return map;
  };

  // CHANGED: Using SR_NO instead of TRANSACTION_ID
  const rowSpanMap = getRowSpanMap(purchase_report_item_list, "SR_NO");

  return (
    <div className="container w-full" style={{ display: "grid" }}>
      <PageHeading title={"SALES REPORT"} right={<BackButton />} />

      <div className="transactionMain">
        <div style={{ width: "180px" }}>
          <Input
            label={"FROM DATE"}
            type={"date"}
            value={addData?.from_date}
            onChange={(e) => {
              if (e.target.value.length <= 10) {
                setAddData({ ...addData, from_date: e.target.value });
              }
            }}
          />
        </div>
        <div style={{ width: "180px" }}>
          <Input
            label={"TO DATE"}
            value={addData?.to_date}
            onChange={(e) => {
              if (e.target.value.length <= 10) {
                setAddData({ ...addData, to_date: e.target.value });
              }
            }}
            type={"date"}
          />
        </div>

        <div style={{ width: "220px" }}>
          <Dropdown
            label={"Select Type Of Sales"}
            value={addData?.action}
            onChange={(e) => {
              setAddData({
                ...addData,
                action: e.target.value,
                product_code: "",
                product_cat: "",
                custProdDetails: "",
                staffid: "",
                staff_cat: "",
                customer_id: "",
              });
            }}
            options={
              <>
                <option value={""}>SELECT</option>
                <option value={"b2b"}>B2B</option>
                <option value={"b2c"}>B2C</option>
                <option value={"product"}>Product Wise</option>
                <option value={"staff"}>Deliverd By/ Staff Name</option>
                <option value={"customer"}>Customer Wise</option>
                <option value={"vehicle"}>Vehicle Wise</option>
              </>
            }
          />
        </div>

        {addData?.action == "product" && (
          <div style={{ width: "220px" }}>
            <Dropdown
              label={"PRODUCT"}
              value={addData?.product_code}
              onChange={(e) => {
                const data = sales_report_list?.productlist?.filter(
                  (v) => v?.ID == e.target.value
                )?.[0];
                setAddData({
                  ...addData,
                  product_code: e.target.value,
                  product_cat: data ? data?.CAT_TYPE : "",
                  custProdDetails: data
                    ? data?.CAT_NAME == "DOMESTIC" ||
                      data?.CAT_NAME == "COMMERCIAL" ||
                      data?.CAT_NAME == "REGULATOR"
                      ? `${data?.CAT_NAME} - ${data?.CAT_DESC}`
                      : `${data?.CAT_DESC} - ${data?.PROD_BRAND} - ${data?.PROD_NAME}`
                    : "",
                });
              }}
              options={
                <>
                  <option value={""}>SELECT</option>
                  {sales_report_list?.productlist?.map((v, i) => (
                    <option value={v?.ID} key={i}>
                      {v?.CAT_NAME == "DOMESTIC" ||
                      v?.CAT_NAME == "COMMERCIAL" ||
                      v?.CAT_NAME == "REGULATOR"
                        ? `${v?.CAT_NAME} - ${v?.CAT_DESC}`
                        : `${v?.CAT_DESC} - ${v?.PROD_BRAND} - ${v?.PROD_NAME}`}
                    </option>
                  ))}
                </>
              }
            />
          </div>
        )}
        {addData?.action == "staff" && (
          <div style={{ width: "220px" }}>
            <Dropdown
              label={"DELIVERED BY/STAFF NAME"}
              value={addData?.staffid}
              onChange={(e) => {
                const data = sales_report_list?.customerlist?.filter(
                  (v) => v?.ID == e.target.value
                )?.[0];
                setAddData({
                  ...addData,
                  staffid: e.target.value,
                  staff_cat: data ? data?.DESIGNATION : "",
                  custProdDetails: data ? data?.EMP_NAME : "",
                });
              }}
              options={
                <>
                  <option value={""}>SELECT</option>
                  {sales_report_list?.customerlist?.map((v, i) => (
                    <option value={v?.ID} key={i}>
                      {v?.EMP_NAME}
                    </option>
                  ))}
                </>
              }
            />
          </div>
        )}

        {addData?.action == "customer" && (
          <div style={{ width: "220px" }}>
            <Dropdown
              label={"CUSTOMER NAME"}
              value={addData?.customer_id}
              onChange={(e) => {
                const data = transition_complete_list?.Customer?.filter(
                  (v) => v?.ID == e.target.value
                );
                setAddData({
                  ...addData,
                  customer_id: e.target.value,
                  custProdDetails:
                    data?.length > 0
                      ? data?.[0]?.cvo_name?.toUpperCase()
                      : e.target.value
                      ? "CASH SALES"
                      : "",
                });
              }}
              options={
                <>
                  <option value={""}>SELECT</option>
                  <option value={"CASH SALES"}>CASH SALES</option>
                  {transition_complete_list?.Customer?.map((v, i) => (
                    <option key={i} value={v?.ID}>
                      {v?.cvo_name?.toUpperCase()}
                    </option>
                  ))}
                </>
              }
            />
          </div>
        )}
        {addData?.action == "vehicle" && (
          <div style={{ width: "220px" }}>
            <Dropdown
              label={"VEHICLE"}
              value={addData?.vehicleid}
              onChange={(e) => {
                const data = sales_report_list?.vehiclelist?.filter(
                  (v) => v?.ID == e.target.value
                );
                setAddData({
                  ...addData,
                  vehicleid: e.target.value,
                  custProdDetails:
                    data?.length > 0
                      ? data?.[0]?.cvo_name?.toUpperCase()
                      : e.target.value,
                });
              }}
              options={
                <>
                  <option value={""}>SELECT</option>

                  {sales_report_list?.vehiclelist?.map((v, i) => (
                    <option key={i} value={v?.ID}>
                      {v?.VEHICLE_NO} - {v?.VEHICLE_MAKE}
                    </option>
                  ))}
                </>
              }
            />
          </div>
        )}

        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <Button
            title={"SEARCH"}
            onClick={async () => {
              await setShowData(false);
              await setSerchInput("");
              await setPageNo(1);
              // await setEntries(5);
              get_list(addData, "main");
            }}
          />
        </div>
      </div>

      {showData && totalCount != 0 ? (
        <>
          <div className="SFromDate">
            <span style={{ fontSize: "11PX" }}>FROM DATE :</span>
            <p className="FDATE">
              {moment(addDataPre?.from_date).format("DD/MM/YY")}
            </p>
            <span style={{ fontSize: "11PX" }}>TO DATE :</span>
            <p className="FDATE">
              {moment(addDataPre?.to_date).format("DD/MM/YY")}
            </p>
            <span style={{ fontSize: "11PX" }}>SELECTED:</span>
            <h6 className="PDS">{addDataPre?.custProdDetails}</h6>
          </div>

          <Pagination3
            count={0}
            download={true}
            PDFDown={() => get_list(addDataPre, "pdf")}
            excelDown={() => get_list(addDataPre, "excel")}
            top={true}
            totalCount={totalCount > SearchCount ? SearchCount : totalCount}
            SerchInput={serchInput}
            serchChange={(e) => {
              setSerchInput(e.target.value);
              setPrevSearch(serchInput);
              setPageNo(1);
            }}
            pageNo={pageNo}
            setPageNo={setPageNo}
            entries={entries}
            setEntries={setEntries}
          >
            {purchase_report_item_list?.length == 0 ? (
              <NoData mt={30} />
            ) : (
              <Table
                headData={table_header}
                body={
                  <>
                    {(() => {
                      // CHANGED: Track rendered SR_NO instead of TRANSACTION_ID
                      const renderedSrNos = new Set();

                      return purchase_report_item_list?.map((v, i) => {
                        // CHANGED: Check SR_NO instead of TRANSACTION_ID
                        const isFirstOccurrence = !renderedSrNos.has(v?.SR_NO);

                        if (isFirstOccurrence) {
                          renderedSrNos.add(v?.SR_NO);
                        }

                        return (
                          <tr
                            key={i}
                            // style={{
                            //   borderTop: isFirstOccurrence
                            //     ? "2px solid #1e3c72"
                            //     : undefined,
                            // }}
                          >
                            <td>{v?.SR_NO}</td>
                            <td>{v?.INV_DATE}</td>
                            <td>{v?.GODOWN_NAME || "-"}</td>
                            <td>
                              {v?.CAT_NAME} - {v?.CAT_DESC}
                            </td>
                            <td>{v?.HSN_CODE}</td>
                            <td>{v?.GSTP}</td>
                            <td>{v?.CVO_NAME || "NA"}</td>
                            <td>{v?.CVO_TIN || "NA"}</td>
                            <td>{v?.EMP_NAME}</td>
                            <td>{v?.QUANTITY}</td>
                            <td>{v?.PREPAID}</td>
                            <td>{v?.PSV}</td>
                            <td>{v?.EMPTY_RECEIVED}</td>
                            <td>NOS</td>
                            <td>{v?.UNIT_RATE}</td>
                            <td>{v?.DISC_UNIT_RATE}</td>
                            <td>{Number(v?.TAXABLE_VALUE)?.toFixed(2)}</td>
                            <td>{Number(v?.IGST_AMOUNT)?.toFixed(2)}</td>
                            <td>{Number(v?.CGST_AMOUNT)?.toFixed(2)}</td>
                            <td>{Number(v?.SGST_AMOUNT)?.toFixed(2)}</td>
                            <td>{Number(v?.INV_AMOUNT)?.toFixed(2)}</td>

                            {/* CHANGED: Merge based on SR_NO */}
                            {isFirstOccurrence && (
                              <>
                                <td
                                  rowSpan={rowSpanMap[v?.SR_NO]}
                                  style={
                                    {
                                      // backgroundColor: "#e8f5e9",
                                      // fontWeight: "600",
                                      // verticalAlign: "middle",
                                      // textAlign: "center",
                                      // borderLeft: "2px solid #cbd5e0",
                                      // borderRight: "2px solid #cbd5e0",
                                    }
                                  }
                                >
                                  {Number(v?.CASH_RECEIVED)?.toFixed(2)}
                                </td>
                                <td
                                  rowSpan={rowSpanMap[v?.SR_NO]}
                                  style={
                                    {
                                      // backgroundColor: "#e8f5e9",
                                      // fontWeight: "600",
                                      // verticalAlign: "middle",
                                      // textAlign: "center",
                                      // borderRight: "2px solid #cbd5e0",
                                    }
                                  }
                                >
                                  {Number(v?.ONLINE_RECEIVED)?.toFixed(2)}
                                </td>
                                <td
                                  rowSpan={rowSpanMap[v?.SR_NO]}
                                  style={
                                    {
                                      // backgroundColor: "#f0f4f8",
                                      // fontWeight: "500",
                                      // verticalAlign: "middle",
                                      // textAlign: "center",
                                      // borderRight: "2px solid #cbd5e0",
                                    }
                                  }
                                >
                                  {v?.TRANSACTION_ID || "-"}
                                </td>
                                <td
                                  rowSpan={rowSpanMap[v?.SR_NO]}
                                  style={
                                    {
                                      // backgroundColor: "#f0f4f8",
                                      // fontWeight: "500",
                                      // verticalAlign: "middle",
                                      // textAlign: "center",
                                      // borderRight: "2px solid #cbd5e0",
                                    }
                                  }
                                >
                                  {v?.BANK_ACCOUNT || "-"}
                                </td>
                              </>
                            )}
                            <td>{v?.CREATED_NAME}</td>
                            <td>
                              {moment(v?.CREATED_DATE).format(
                                "DD/MM/YYYY hh:mm A"
                              )}
                            </td>
                          </tr>
                        );
                      });
                    })()}

                    {/* Total Row */}
                    <tr style={{ backgroundColor: "#f8f9fa" }}>
                      <td colSpan={7} />
                      <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        TOTAL
                      </td>
                      <td />
                      <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        {Number(totalData?.quantity).toFixed(0)}
                      </td>
                      <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        {Number(totalData?.PREPAID).toFixed(0)}
                      </td>
                      <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        {Number(totalData?.PSV).toFixed(0)}
                      </td>
                      <td colSpan={4} />
                      <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        {Number(totalData?.taxable)?.toFixed(2)}
                      </td>
                      <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        {Number(totalData?.igst)?.toFixed(2)}
                      </td>
                      <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        {Number(totalData?.cgst)?.toFixed(2)}
                      </td>
                      <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        {Number(totalData?.sgst)?.toFixed(2)}
                      </td>
                      <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        {Number(totalData?.inv_amount)?.toFixed(2)}
                      </td>
                      <td colSpan={5} />
                    </tr>
                  </>
                }
              />
            )}
          </Pagination3>
        </>
      ) : showData ? (
        <NoData title={"NO RECORDS FOUND"} color="red" mt={30} />
      ) : (
        ""
      )}

      <div style={{ height: "10px" }}></div>
      {open && (
        <SmallModal
          isOpen={open}
          setIsOpen={setOpen}
          title={"Alerts"}
          mess={mess}
          okbtn={setOpen}
        />
      )}
      {showLoader && <Loader />}
    </div>
  );
};

export default SalesReport;
// import React, { useEffect, useState } from "react";
// import { BackButton } from "../../components/btn/Buttons";
// import PageHeading from "../../components/PageHeading";
// import { Input } from "../../components/inputs/Inputs";
// import Dropdown from "../../components/inputs/Dropdown";
// import Button from "../../components/btn/Button";
// import { useSelector } from "react-redux";
// import Table from "../../components/table/Table";
// import store from "../../redux/store";
// import { get_sales_report_list } from "./transactionReportSlice";
// import { DateValidator2, DateValidatorReports } from "../../utils/validation";
// import moment from "moment";
// import SmallModal from "../../components/modal/SmallModal";
// import Loader from "../../components/Loader";
// import { sales_report_api } from "../../utils/apis";
// import {
//   Pagination2,
//   Pagination3,
// } from "../../components/pagination/pagination";
// import NoData from "../../components/NoData";
// import { downloadExcel, exportPDF } from "../../utils/utils";
// import { get_customer_vender_list } from "../MasterData/masterdataSlice";
// import { Alerts } from "../../components/Alerts/Alerts";
// import { get_transition_complete_list } from "../transactions/trasactionsSlice";
// import SearchApiHook from "../../CustomHooks/SearchApiHook";

// const SalesReport = () => {
//   const [addData, setAddData] = useState({});
//   const [addDataPre, setAddDataPre] = useState({});
//   const [showLoader, setShowLoader] = useState(false);
//   const [open, setOpen] = useState(false);
//   const [mess, setMess] = useState("");
//   const [totalCount, setTotalCount] = useState("50");
//   const [entries, setEntries] = useState("5");
//   const [pageNo, setPageNo] = useState(1);
//   const [serchInput, setSerchInput] = useState("");
//   const [showData, setShowData] = useState(false);
//   const [prevSearch, setPrevSearch] = useState("");
//   const [SearchCount, setSearchCount] = useState(0);
//   const [purchase_report_item_list, setPurchase_report_item_list] = useState(
//     []
//   );

//   const { transition_complete_list } = useSelector(
//     (state) => state.transactions
//   );

//   const [totalData, setTotalData] = useState({});
//   const { firm_name } = useSelector((state) => state.profile);
//   const { sales_report_list } = useSelector((state) => state.transactionReport);
//   const { eff_date, user_id, today } = useSelector((state) => state.other);

//   useEffect(() => {
//     store.dispatch(get_sales_report_list());
//     store.dispatch(get_transition_complete_list());
//   }, []);

//   const fetchData = () => {
//     if (showData) {
//       get_list(addDataPre);
//     }
//   };
//   SearchApiHook(fetchData, serchInput?.trim(), prevSearch, [entries, pageNo]);

//   const table_data = (addData, total) => {
//     const data = [
//       ...addData?.map((v, i) => [
//         i + 1,
//         v?.SR_NO,
//         v?.INV_DATE,
//         v?.GODOWN_NAME || "-",
//         `${v?.CAT_NAME} - ${v?.CAT_DESC}`,
//         v?.HSN_CODE,
//         v?.GSTP,
//         v?.CVO_NAME,
//         v?.CVO_TIN || "NA",
//         v?.EMP_NAME,
//         Number(v?.QUANTITY || 0),
//         Number(v?.PREPAID || 0),
//         Number(v?.PSV || 0),
//         Number(v?.EMPTY_RECEIVED),
//         "NOS",
//         v?.UNIT_RATE,
//         v?.DISC_UNIT_RATE,
//         Number(v?.TAXABLE_VALUE),
//         Number(v?.IGST_AMOUNT),
//         Number(v?.CGST_AMOUNT),
//         Number(v?.SGST_AMOUNT),
//         Number(v?.INV_AMOUNT),
//         Number(v?.CASH_RECEIVED),
//         Number(v?.ONLINE_RECEIVED),
//         v?.TRANSACTION_ID,
//         v?.BANK_ACCOUNT,
//         v?.CREATED_NAME,
//       ]),
//       [
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "TOTAL",
//         "",
//         Number(total?.quantity),
//         Number(total?.PREPAID),
//         Number(total?.PSV),
//         "",
//         "",
//         // Number(total?.unit_price),
//         // Number(total?.discount),
//         "",
//         "",
//         Number(total?.taxable),
//         Number(total?.igst),
//         Number(total?.cgst),
//         Number(total?.sgst),
//         Number(total?.inv_amount),
//       ],
//     ];

//     return data;
//   };

//   //   "Sales Report-Remove ->Hsn , Gst percentage, Igst,Cgst, Sgst,

//   // Add - Cash Received , Online Received, Created To Online Bank"

//   const table_header = [
//     "INVOICE NO",
//     "INVOICE DATE",
//     "GODOWN NAME",
//     "PRODUCT	",
//     "HSN CODE",
//     "GST RATE",
//     "CUSTOMER	",
//     "CUSTOMER GSTIN",
//     "DELIVERED BY/STAFF NAME",
//     "QTY",
//     "PREPAID / ONLINE",
//     "PSV CYLINDERS",
//     "EMPTIES RECEIVED",
//     "UNITS	",
//     "UNIT PRICE",
//     "DISCOUNT",
//     "TAXABLE VALUE",
//     "IGST AMOUNT",
//     "CGST AMOUNT",
//     "SGST AMOUNT",
//     "INVOICE AMOUNT",
//     "CASH RECEIVED",
//     "ONLINE RECEIVED",
//     "TRANSACTION ID",
//     "BANK ACCOUNT",
//     ...(addData?.action == "vehicle" ? ["VEHICLE NO", "VEHICLE MAKE"] : []),
//     "CREATED BY",
//   ];

//   const export_pdf = (addData, data, total) => {
//     exportPDF({
//       table_data: table_data(data, total),
//       table_headers: ["S.No.", ...table_header],
//       fileName: `${firm_name} - SALES REPORTS -- FROM DATE : ${moment(
//         addData?.from_date
//       ).format("DD/MM/YY")} & TO DATE : ${moment(addData?.to_date).format(
//         "DD/MM/YY"
//       )}   :: SELECTED : : ${addData?.custProdDetails}`,
//       tableName: `${firm_name} - SALES REPORTS -- FROM DATE : ${moment(
//         addData?.from_date
//       ).format("DD/MM/YY")} & TO DATE : ${moment(addData?.to_date).format(
//         "DD/MM/YY"
//       )}   :: SELECTED : : ${addData?.custProdDetails}`,
//     });
//   };

//   const export_excel = (addData, data, total) => {
//     downloadExcel(
//       table_data(data, total),
//       ["S.No.", ...table_header],
//       `${firm_name} - SALES REPORTS -- FROM DATE : ${moment(
//         addData?.from_date
//       ).format("DD/MM/YY")} & TO DATE : ${moment(addData?.to_date).format(
//         "DD/MM/YY"
//       )}   :: SELECTED : : ${addData?.custProdDetails}`
//     );
//   };

//   const get_list = async (addData, data1 = "") => {
//     const data = validate(addData);
//     if (data?.length == 0) {
//       try {
//         setShowLoader(true);
//         const body = new FormData();
//         body.append("action", addData?.action);
//         body.append("agencyid", user_id);
//         body.append("sdate", addData?.from_date);
//         body.append("edate", addData?.to_date);
//         // body.append("page", data1?.length > 1 ? 1 : pageNo);
//         // body.append("limit", data1?.length > 1 ? totalCount : entries);
//         body.append("page", data1?.length > 1 || data1 == "main" ? 1 : pageNo);
//         body.append(
//           "limit",
//           data1?.length > 1 ? (data1 == "main" ? entries : totalCount) : entries
//         );
//         body.append("search", data1 == "main" ? "" : serchInput);
//         if (addData?.action == "staff") {
//           body.append("staffid", addData?.staffid);
//         } else if (addData?.action == "product") {
//           body.append("productid", addData?.product_code);
//           body.append("prod_cat", addData?.product_cat);
//         } else if (addData?.action == "customer") {
//           body.append(
//             "customerid",
//             addData?.customer_id == "CASH SALES" ? 0 : addData?.customer_id
//           );
//         }
//         if (addData?.action == "vehicle") {
//           body.append("vehicle_id", addData?.vehicleid);
//         }
//         const response = await sales_report_api(body);
//         setShowLoader(false);
//         if (response.success) {
//           if (data1 == "excel") {
//             export_excel(
//               addData,
//               response?.data || response?.productlist,
//               response?.total
//             );
//           } else if (data1 == "pdf") {
//             export_pdf(
//               addData,
//               response?.data || response?.productlist,
//               response?.total
//             );
//           } else {
//             setPurchase_report_item_list(
//               response?.data || response?.productlist
//             );
//             setTotalCount(response?.totalcount);
//             setSearchCount(response?.searchcount);
//             setShowData(true);
//             setAddDataPre(addData);
//             setTotalData(response?.total);
//           }
//         } else if (!response.success) {
//           setMess(response?.message);
//           setOpen(true);
//         }
//       } catch (error) {
//         console.log(error);
//       }
//     } else {
//       setMess(<Alerts data={data} />);
//       setOpen(true);
//     }
//   };

//   const validate = (addData) => {
//     const data = [];
//     const DateValidatorReportsData = DateValidatorReports(
//       moment(addData?.from_date).format("DD/MM/YYYY"),
//       moment(addData?.to_date).format("DD/MM/YYYY")
//     );
//     if (
//       !addData?.from_date ||
//       (addData?.from_date && addData?.from_date?.length != 10)
//     ) {
//       data.push("Please Enter From Date");
//     } else if (
//       !addData?.to_date ||
//       (addData?.to_date && addData?.to_date?.length != 10)
//     ) {
//       data.push("Please Enter TO DATE");
//     } else if (DateValidatorReportsData != true) {
//       data.push(...DateValidatorReportsData);
//     }
//     if (!addData?.action || (addData?.action && addData?.action?.length == 0)) {
//       data.push("Please Select Type of Sales");
//     }
//     // else {
//     //   if (
//     //     addData?.action == "customer" &&
//     //     (!addData?.customer_id ||
//     //       (addData?.customer_id && addData?.customer_id?.length == 0))
//     //   ) {
//     //     data.push("Please Select Customer Name");
//     //   } else if (
//     //     addData?.action == "product" &&
//     //     (!addData?.product_code ||
//     //       (addData?.product_code && addData?.product_code?.length == 0))
//     //   ) {
//     //     data.push("Please Select Customer Name");
//     //   } else if (
//     //     addData?.action == "staff" &&
//     //     (!addData?.staffid ||
//     //       (addData?.staffid && addData?.staffid?.length == 0))
//     //   ) {
//     //     data.push("Please Select Staff Name");
//     //   }
//     // }

//     return data;
//   };
//   return (
//     <div className="container ">
//       <PageHeading title={"SALES REPORT"} right={<BackButton />} />
//       <div className="transactionMain">
//         <div style={{ width: "180px" }}>
//           <Input
//             label={"FROM DATE"}
//             type={"date"}
//             value={addData?.from_date}
//             onChange={(e) => {
//               if (e.target.value.length <= 10) {
//                 setAddData({ ...addData, from_date: e.target.value });
//               }
//             }}
//           />
//         </div>
//         <div style={{ width: "180px" }}>
//           <Input
//             label={"TO DATE"}
//             value={addData?.to_date}
//             onChange={(e) => {
//               if (e.target.value.length <= 10) {
//                 setAddData({ ...addData, to_date: e.target.value });
//               }
//             }}
//             type={"date"}
//           />
//         </div>

//         <div style={{ width: "220px" }}>
//           <Dropdown
//             label={"Select Type Of Sales"}
//             value={addData?.action}
//             onChange={(e) => {
//               setAddData({
//                 ...addData,
//                 action: e.target.value,
//                 product_code: "",
//                 product_cat: "",
//                 custProdDetails: "",
//                 staffid: "",
//                 staff_cat: "",
//                 customer_id: "",
//               });
//             }}
//             options={
//               <>
//                 <option value={""}>SELECT</option>
//                 <option value={"b2b"}>B2B</option>
//                 <option value={"b2c"}>B2C</option>
//                 <option value={"product"}>Product Wise</option>
//                 <option value={"staff"}>Deliverd By/ Staff Name</option>
//                 <option value={"customer"}>Customer Wise</option>
//                 <option value={"vehicle"}>Vehicle Wise</option>
//               </>
//             }
//           />
//         </div>

//         {addData?.action == "product" && (
//           <div style={{ width: "220px" }}>
//             <Dropdown
//               label={"PRODUCT"}
//               value={addData?.product_code}
//               onChange={(e) => {
//                 const data = sales_report_list?.productlist?.filter(
//                   (v) => v?.ID == e.target.value
//                 )?.[0];
//                 setAddData({
//                   ...addData,
//                   product_code: e.target.value,
//                   product_cat: data ? data?.CAT_TYPE : "",
//                   custProdDetails: data
//                     ? data?.CAT_NAME == "DOMESTIC" ||
//                       data?.CAT_NAME == "COMMERCIAL" ||
//                       data?.CAT_NAME == "REGULATOR"
//                       ? `${data?.CAT_NAME} - ${data?.CAT_DESC}`
//                       : `${data?.CAT_DESC} - ${data?.PROD_BRAND} - ${data?.PROD_NAME}`
//                     : "",
//                 });
//               }}
//               options={
//                 <>
//                   <option value={""}>SELECT</option>
//                   {sales_report_list?.productlist?.map((v, i) => (
//                     <option value={v?.ID} key={i}>
//                       {v?.CAT_NAME == "DOMESTIC" ||
//                       v?.CAT_NAME == "COMMERCIAL" ||
//                       v?.CAT_NAME == "REGULATOR"
//                         ? `${v?.CAT_NAME} - ${v?.CAT_DESC}`
//                         : `${v?.CAT_DESC} - ${v?.PROD_BRAND} - ${v?.PROD_NAME}`}
//                     </option>
//                   ))}
//                 </>
//               }
//             />
//           </div>
//         )}
//         {addData?.action == "staff" && (
//           <div style={{ width: "220px" }}>
//             <Dropdown
//               label={"DELIVERED BY/STAFF NAME"}
//               value={addData?.staffid}
//               onChange={(e) => {
//                 const data = sales_report_list?.customerlist?.filter(
//                   (v) => v?.ID == e.target.value
//                 )?.[0];
//                 setAddData({
//                   ...addData,
//                   staffid: e.target.value,
//                   staff_cat: data ? data?.DESIGNATION : "",
//                   custProdDetails: data ? data?.EMP_NAME : "",
//                 });
//               }}
//               options={
//                 <>
//                   <option value={""}>SELECT</option>
//                   {sales_report_list?.customerlist?.map((v, i) => (
//                     <option value={v?.ID} key={i}>
//                       {v?.EMP_NAME}
//                     </option>
//                   ))}
//                 </>
//               }
//             />
//           </div>
//         )}

//         {addData?.action == "customer" && (
//           <div style={{ width: "220px" }}>
//             <Dropdown
//               label={"CUSTOMER NAME"}
//               value={addData?.customer_id}
//               onChange={(e) => {
//                 const data = transition_complete_list?.Customer?.filter(
//                   (v) => v?.ID == e.target.value
//                 );
//                 setAddData({
//                   ...addData,
//                   customer_id: e.target.value,
//                   custProdDetails:
//                     data?.length > 0
//                       ? data?.[0]?.cvo_name?.toUpperCase()
//                       : e.target.value
//                       ? "CASH SALES"
//                       : "",
//                 });
//               }}
//               options={
//                 <>
//                   <option value={""}>SELECT</option>
//                   <option value={"CASH SALES"}>CASH SALES</option>
//                   {transition_complete_list?.Customer?.map((v, i) => (
//                     <option key={i} value={v?.ID}>
//                       {v?.cvo_name?.toUpperCase()}
//                     </option>
//                   ))}
//                 </>
//               }
//             />
//           </div>
//         )}
//         {addData?.action == "vehicle" && (
//           <div style={{ width: "220px" }}>
//             <Dropdown
//               label={"VEHICLE"}
//               value={addData?.vehicleid}
//               onChange={(e) => {
//                 const data = sales_report_list?.vehiclelist?.filter(
//                   (v) => v?.ID == e.target.value
//                 );
//                 setAddData({
//                   ...addData,
//                   vehicleid: e.target.value,
//                   custProdDetails:
//                     data?.length > 0
//                       ? data?.[0]?.cvo_name?.toUpperCase()
//                       : e.target.value,
//                 });
//               }}
//               options={
//                 <>
//                   <option value={""}>SELECT</option>

//                   {sales_report_list?.vehiclelist?.map((v, i) => (
//                     <option key={i} value={v?.ID}>
//                       {v?.VEHICLE_NO} - {v?.VEHICLE_MAKE}
//                     </option>
//                   ))}
//                 </>
//               }
//             />
//           </div>
//         )}

//         <div style={{ display: "flex", alignItems: "flex-end" }}>
//           <Button
//             title={"SEARCH"}
//             onClick={async () => {
//               await setShowData(false);
//               await setSerchInput("");
//               await setPageNo(1);
//               // await setEntries(5);
//               get_list(addData, "main");
//             }}
//           />
//         </div>
//       </div>

//       {showData && totalCount != 0 ? (
//         <>
//           <div className="SFromDate">
//             <span style={{ fontSize: "11PX" }}>FROM DATE :</span>
//             <p className="FDATE">
//               {moment(addDataPre?.from_date).format("DD/MM/YY")}
//             </p>
//             <span style={{ fontSize: "11PX" }}>TO DATE :</span>
//             <p className="FDATE">
//               {moment(addDataPre?.to_date).format("DD/MM/YY")}
//             </p>
//             <span style={{ fontSize: "11PX" }}>SELECTED:</span>
//             <h6 className="PDS">{addDataPre?.custProdDetails}</h6>
//           </div>

//           <Pagination3
//             count={0}
//             download={true}
//             PDFDown={() => get_list(addDataPre, "pdf")}
//             excelDown={() => get_list(addDataPre, "excel")}
//             top={true}
//             totalCount={totalCount > SearchCount ? SearchCount : totalCount}
//             SerchInput={serchInput}
//             serchChange={(e) => {
//               setSerchInput(e.target.value);
//               setPrevSearch(serchInput);
//               setPageNo(1);
//             }}
//             pageNo={pageNo}
//             setPageNo={setPageNo}
//             entries={entries}
//             setEntries={setEntries}
//           >
//             {purchase_report_item_list?.length == 0 ? (
//               <NoData mt={30} />
//             ) : (
//               <Table
//                 headData={table_header}
//                 body={
//                   <>
//                     {purchase_report_item_list?.map((v, i) => (
//                       <tr key={i}>
//                         <td>{v?.SR_NO}</td>
//                         <td>{v?.INV_DATE}</td>
//                         <td>{v?.GODOWN_NAME || "-"}</td>
//                         <td>
//                           {v?.CAT_NAME} - {v?.CAT_DESC}
//                         </td>
//                         <td>{v?.HSN_CODE}</td>
//                         <td>{v?.GSTP}</td>
//                         <td>{v?.CVO_NAME || "NA"}</td>
//                         <td>{v?.CVO_TIN || "NA"}</td>
//                         <td>{v?.EMP_NAME}</td>
//                         <td>{v?.QUANTITY}</td>
//                         <td>{v?.PREPAID}</td>
//                         <td>{v?.PSV}</td>
//                         <td>{v?.EMPTY_RECEIVED}</td>
//                         <td>{"NOS"}</td>
//                         <td>{v?.UNIT_RATE}</td>
//                         <td>{v?.DISC_UNIT_RATE}</td>
//                         <td>{Number(v?.TAXABLE_VALUE)?.toFixed(2)}</td>
//                         <td>{Number(v?.IGST_AMOUNT)?.toFixed(2)}</td>
//                         <td>{Number(v?.CGST_AMOUNT)?.toFixed(2)}</td>
//                         <td>{Number(v?.SGST_AMOUNT)?.toFixed(2)}</td>
//                         <td>{Number(v?.INV_AMOUNT)?.toFixed(2)}</td>
//                         <td>{Number(v?.CASH_RECEIVED)?.toFixed(2)}</td>
//                         <td>{Number(v?.ONLINE_RECEIVED)?.toFixed(2)}</td>
//                         <td>{v?.TRANSACTION_ID}</td>
//                         <td>{v?.BANK_ACCOUNT}</td>
//                         {addData?.action == "vehicle" && (
//                           <>
//                             <td>{v?.VEHICLE_MAKE}</td>
//                             <td>{v?.VEHICLE_NO}</td>
//                           </>
//                         )}
//                         <td>{v?.CREATED_NAME}</td>
//                       </tr>
//                     ))}
//                     <tr>
//                       <td colSpan={7} />
//                       <td style={{ fontWeight: "bold", fontSize: "15px" }}>
//                         TOTAL
//                       </td>
//                       <td />
//                       <td style={{ fontWeight: "bold", fontSize: "15px" }}>
//                         {Number(totalData?.quantity).toFixed(0)}
//                       </td>
//                       <td style={{ fontWeight: "bold", fontSize: "15px" }}>
//                         {Number(totalData?.PREPAID).toFixed(0)}
//                       </td>
//                       <td style={{ fontWeight: "bold", fontSize: "15px" }}>
//                         {Number(totalData?.PSV).toFixed(0)}
//                       </td>
//                       <td colSpan={4} />
//                       {/* <td style={{ fontWeight: "bold", fontSize: "15px" }}>
//                       {Number(totalData?.unit_price)?.toFixed(2)}
//                     </td>
//                     <td style={{ fontWeight: "bold", fontSize: "15px" }}>
//                       {Number(totalData?.discount)?.toFixed(2)}
//                     </td> */}
//                       <td style={{ fontWeight: "bold", fontSize: "15px" }}>
//                         {Number(totalData?.taxable)?.toFixed(2)}
//                       </td>
//                       <td style={{ fontWeight: "bold", fontSize: "15px" }}>
//                         {Number(totalData?.igst)?.toFixed(2)}
//                       </td>
//                       <td style={{ fontWeight: "bold", fontSize: "15px" }}>
//                         {Number(totalData?.cgst)?.toFixed(2)}
//                       </td>
//                       <td style={{ fontWeight: "bold", fontSize: "15px" }}>
//                         {Number(totalData?.sgst)?.toFixed(2)}
//                       </td>
//                       <td style={{ fontWeight: "bold", fontSize: "15px" }}>
//                         {Number(totalData?.inv_amount)?.toFixed(2)}
//                       </td>
//                     </tr>
//                   </>
//                 }
//               />
//             )}
//           </Pagination3>
//         </>
//       ) : showData ? (
//         <NoData title={"NO RECORDS FOUND"} color="red" mt={30} />
//       ) : (
//         ""
//       )}

//       <div style={{ height: "10px" }}></div>

//       {open && (
//         <SmallModal
//           isOpen={open}
//           setIsOpen={setOpen}
//           title={"Alerts"}
//           mess={mess}
//           okbtn={setOpen}
//         />
//       )}
//       {showLoader && <Loader />}
//     </div>
//   );
// };

// export default SalesReport;
